import type { ReadonlyRecord } from '../../utils'

import type { LastTopicMessage, TailedTopicMessage, Topic, TopicsChunks, TopicSubscriptionResponse } from '..'

export type Explorer = Readonly<{
    /**
     * The loaded/loading chunks of topics (multiple per chunk)
     */
    chunks: TopicsChunks

    selectedTopics: readonly Topic<false>['fullPath'][]
    subscriptionResponse: TopicSubscriptionResponse | null

    customTopics: readonly Topic<false>['fullPath'][]

    /**
     * Monitored topics
     */
    latestValues: ReadonlyRecord<Topic<false>['fullPath'], LastTopicMessage | null>

    /**
     * History/Tail
     */
    tailSize: number
    isTailing: boolean
    tail: readonly TailedTopicMessage[]
}>
